// extracted by mini-css-extract-plugin
module.exports = {"volumeHolder":"LocalVideoControls_volumeHolder__eYDy-","timeHolder":"LocalVideoControls_timeHolder__2sVHa","sliderHolder":"LocalVideoControls_sliderHolder__2gj5k"};